import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Session } from 'src/app/models/session';
import { ToastrService } from 'ngx-toastr';
import { ConfirmService } from '../confirm/confirm.service';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.css']
})
export class AdminsComponent implements OnInit {

  constructor(private service: UserService, private session: Session, private toast: ToastrService, private confirm: ConfirmService) { }

  admins = [];
  filter = "";
  ngOnInit() {
    this.getAdmins();
  }

  getAdmins(){
    this.service.getAdmins().subscribe(d=>{
      // this.admins = d.admins.filter(x=> x.email != this.session.user.email);
      this.admins = d.admins;
    })
  }
  showNewAdminDialog = false;

  newAdmin(){
    this.showNewAdminDialog = true;
  }

  newAdminData: any = { nombre: "", apellido: "", email: "", password: "" };

  saveNewAdmin(){
    this.service.createNewAdmin(this.newAdminData).subscribe(d=>{
      this.showNewAdminDialog = false;
      this.toast.success("Administrador creado con éxito");
      this.admins.push(d);
      this.newAdminData = {};
    }, er=>{      
      this.toast.error(er.error);
    })
  }

  eliminarAdmin(admin){
    this.confirm.confirm("Eliminar admin", "Está seguro de eliminar al administrador : " + admin.email + "?").then( (confirmated) =>{
      if(!confirmated) return;
      this.service.eliminarAdmin(admin._id).subscribe(d=>{
        this.toast.success("Administrador eliminado con éxito");
        let i = this.admins.findIndex( (x) => x._id == admin._id);
        if(i>=0) this.admins = this.admins.splice(i,1);
  
      }, er =>{
        this.toast.error(er.error.error);
      })
    })
    
    
  }


  changePasswordUser: any = {};
  changePasswordDialog = false;
  changePassword(user){
    this.changePasswordDialog = true;
    this.changePasswordUser = JSON.parse(JSON.stringify(user));
    this.changePasswordUser.password = "";

  }

  saveNewPassword(){
    this.service.adminCambiarContraseña(this.changePasswordUser._id, this.changePasswordUser.password).subscribe(d=>{
      this.toast.success("Contraseña actualizada con exito");
      this.changePasswordDialog = false;
      this.changePasswordUser = {};
    }, er=>{
      this.toast.error("Error");
    })

  }


  editedAdmin;
  edit(admin){ 
    this.editedAdmin = JSON.parse(JSON.stringify(admin));
  }

  persistEditedAdmin(){
    console.log(this.editedAdmin);
    let body = { nombre: this.editedAdmin.nombre, apellido: this.editedAdmin.apellido, email: this.editedAdmin.email };
    this.service.editAdmin(this.editedAdmin._id, body).subscribe(d=>{
      this.editedAdmin = null;
      this.getAdmins();
    }, er=>{
      this.toast.error(er.error);
    })
    

    
  }
}
